var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          breadcrumbs: _vm.breadcrumbs,
          dense: true,
          hiddenTab: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return [
                _c("v-text-field", {
                  staticStyle: { "max-width": "650px", "min-width": "550px" },
                  attrs: {
                    outlined: "",
                    "single-line": "",
                    dense: "",
                    "hide-details": "",
                    placeholder: "Escribe un RUT o razón social",
                    clearable: "",
                  },
                  on: {
                    input: _vm.handleSearch,
                    "click:clear": _vm.handleClear,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "prepend-inner",
                      fn: function () {
                        return [
                          _c(
                            "v-icon",
                            {
                              staticStyle: {
                                color: "var(--light-grey-500) !important",
                              },
                              attrs: { size: "24" },
                            },
                            [_vm._v("mdi-magnify")]
                          ),
                          _c("v-divider", {
                            staticStyle: {
                              height: "16px",
                              margin: "0 6px",
                              "margin-top": "5px",
                              "border-color": "var(--light-grey-50) !important",
                            },
                            attrs: { vertical: "" },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.search,
                    callback: function ($$v) {
                      _vm.search = $$v
                    },
                    expression: "search",
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "v-col",
        { staticClass: "px-0 mt-20", attrs: { cols: "12" } },
        [
          _vm.loading
            ? _c("skeleton-list")
            : [
                !_vm.suppliersList.length
                  ? _c(
                      "div",
                      {
                        staticClass: "d-flex justify-center align-center",
                        staticStyle: {
                          width: "100%",
                          "min-height": "calc(100vh - 300px)",
                        },
                      },
                      [
                        _c("v-empty-state", {
                          attrs: {
                            type: "suppliers",
                            id: "document",
                            height: 180,
                            hiddenDescription: true,
                            customClass: "mt-6",
                            isFree: true,
                            title: "No existen proveedores para mostrar",
                          },
                        }),
                      ],
                      1
                    )
                  : _c("v-simple-table", {
                      class: [
                        {
                          "fixed-table":
                            _vm.$store.state.base.isExpandNavigationDrawer,
                        },
                      ],
                      attrs: { height: _vm.heightTable, "fixed-header": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function () {
                            return [
                              _c("VTableHeaders", {
                                attrs: { headers: _vm.headers },
                                on: { sort: _vm.setSort },
                              }),
                              _c("v-divider", {
                                staticStyle: {
                                  position: "absolute",
                                  "margin-top": "-6px",
                                  "margin-left": "-5px",
                                  "z-index": "2",
                                  "min-width": "100%",
                                },
                              }),
                              _c(
                                "tbody",
                                _vm._l(_vm.suppliersList, function (item, i) {
                                  return _c(
                                    "tr",
                                    {
                                      directives: [
                                        {
                                          name: "intersect",
                                          rawName: "v-intersect",
                                          value:
                                            i + 1 === _vm.suppliersList?.length
                                              ? _vm.onLoadMore
                                              : "",
                                          expression:
                                            "(i + 1) === suppliersList?.length ? onLoadMore : ''",
                                        },
                                      ],
                                      key: i,
                                      on: {
                                        mouseenter: function ($event) {
                                          _vm.hoveredRow = i
                                        },
                                        mouseleave: function ($event) {
                                          return _vm.handleRowLeave(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "td",
                                        { staticClass: "body-2" },
                                        [
                                          item.name || item.tax_id
                                            ? [
                                                item.name
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 d-inline-block text-truncate",
                                                        staticStyle: {
                                                          "max-width": "95%",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "d-block body-2 text--disabled font-italic",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Sin especificar"
                                                        ),
                                                      ]
                                                    ),
                                                item.tax_id
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "mt-n1 caption grey-300--text d-block",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "generals.RUT"
                                                            )
                                                          ) +
                                                            " " +
                                                            _vm._s(item.tax_id)
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-2 text--disabled font-italic",
                                                },
                                                [_vm._v("Sin especificar")]
                                              ),
                                        ],
                                        2
                                      ),
                                      _c("td", { staticClass: "body-2" }, [
                                        item.tax_settings
                                          ?.cl_activity_description ||
                                        item.business_activity
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "d-inline-block text-truncate",
                                                staticStyle: {
                                                  "max-width": "96%",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.tax_settings
                                                      ?.cl_activity_description ||
                                                      item.business_activity
                                                  )
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "body-2 text--disabled",
                                              },
                                              [_vm._v("Sin especificar")]
                                            ),
                                      ]),
                                      _c(
                                        "td",
                                        { staticClass: "body-2 text-end" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("dateTimeSecond")(
                                                item.created
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "td",
                                        {
                                          staticClass: "text-end",
                                          staticStyle: { width: "180px" },
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.hoveredRow === i ||
                                                    _vm.confirmAdd ===
                                                      item.id ||
                                                    _vm.successAdd === item.id,
                                                  expression:
                                                    "hoveredRow === i || confirmAdd === item.id || successAdd === item.id",
                                                },
                                              ],
                                              attrs: {
                                                color: _vm.getButtonColor(
                                                  item.id
                                                ),
                                                small: "",
                                                loading:
                                                  _vm.loadingAdd === item.id,
                                                disabled:
                                                  _vm.successAdd === item.id,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleButtonClick(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getButtonText(item.id)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
              ],
        ],
        2
      ),
      _c(
        "v-snackbar",
        {
          attrs: {
            timeout: 3000,
            color: "#222835",
            top: "",
            "min-width": "50%",
          },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        staticClass: "white--text mr-4",
                        attrs: { text: "" },
                        on: { click: _vm.handleUndo },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Deshacer ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.showSnackbar,
            callback: function ($$v) {
              _vm.showSnackbar = $$v
            },
            expression: "showSnackbar",
          },
        },
        [
          _c("span", { staticClass: "white--text" }, [
            _vm._v(
              _vm._s(_vm.snackbarSupplier?.name || "Nombre del proveedor") +
                " agregado a la categoría " +
                _vm._s(_vm.categoryName || "Nombre de la categoría") +
                " con éxito"
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }